// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {

    firebase: {
        apiKey: "AIzaSyAJR6aMZMPo4NTZJMS0nyCmyOlTC_6ou-8",
        authDomain: "baguu-uat.firebaseapp.com",
        projectId: "baguu-uat",
        storageBucket: "baguu-uat.appspot.com",
        messagingSenderId: "497970479609",
        appId: "1:497970479609:web:d12af3cb9ba50ae5747d28",
        measurementId: "G-4DNJWWPQJG"
    },
    production: false,
    mapache: {
        version: 'v3.8.6',
        hosts: {
            ecosistema: 'https://back-baguu.algorithmdata.ai/cassandra',
            notifications: 'https://back-baguu.algorithmdata.ai/notifications',
            wallet: 'https://back-baguu.algorithmdata.ai/virtualcard',
            sales: 'https://back.baguu.mx/payments', //-->Pro
            //sales: 'https://back-baguu.algorithmdata.ai/payments',
            chatia: 'https://back-baguu.algorithmdata.ai/chatia',
        },
        endpoints: {
            categories: '/business/type',
            businesses: '/business/position',
            businesseNotsPos: '/business/term',
            business: '/owner/{ownerId}/business',
            businessId: '/business/{businessId}',
            businessOptions: '/business/type/business/{businessId}',
            businessBanner: '/owner/business/{businessId}/banner',
            products: '/owner/{ownerId}/business/{businessId}/catalogue',
            address: '/addresses',
            ordersHistory: '/appointment/customer/mail/{email}/month/{firstDayMonth}',
            ordersHistoryListSales: '/sales/mail/{email}/month/{dayMonth}/now/{today}',
            receipt: '/sales/receipt/{saleId}',
            appointment: '/owner/{ownerId}/business/{businessId}/appointment',
            appointmentUpdate: '/appointment/{appointmentId}/status/{statusId}',
            geolocalization: '/addresses/location',
            notifications: {
                list: '/user/{userId}/status/1,2',
                seen: '/{notificationId}/status/2',
                delete: '/{notificationId}',
            },
            sales: '/owner/{ownerId}/business/{businessId}/sale',
            qualify: '/owner/{ownerId}/business/{businessId}/sale/{saleId}/score/{scoreId}',
            scoreImage: '/owner/{ownerId}/business/{businessId}/score',
            cardTransactions: '/sales/card/{cardId}',
            wallet: {
                cards: '/card/user-find/{ownerId}',
                addBalance: '/card/balance/add',
                createCard: '/card'
            },
            salesMit: {
                card: '/card',
                reference: '/reference/{referenceId}'
            },
            salesPraga: {
                card: '/praga',
                reference: '/reference/{referenceId}'
            },
            help: '/mail/contact',
            shoppingCart: {
                cartForId: '/shopping-cart/{cartId}',
                cartForRequest: '/shopping-cart',
                cartForCustomer: '/shopping-cart/customer/{id}',
                guest: '/shopping-cart/guest'
            },
            hallowen: '/hallowen',
            appparameters: '/appparameters',
            pets: {
                listPetsOwner: '/pets/search/owner/{ownerId}',
                deletePets: '/pets/delete/id/{id}',
                savePets: '/pets/save',
                updatePets: '/pets/update',
                listId: '/pets/search/id/{id}',
                size: '/pets/size',
                weight: '/pets/weight',
                species: '/pets/species',
                genre: '/pets/genre',
                pdfExp: '/pets/pdf/id/{id}',
                deleteDocs: '/pets/document/delete/pet/{id}/owner/{ownerId}/document/{idDoc}',
                saveDocs: '/pets/document/pet/{id}'
            },
            chat: '/chat',
            termsAndCond: {
                check: '/doclegal/user/acceptances?uid={uid}&documentType={type}',
                getDocument: '/doclegal/documents/latest?type={type}',
                accept: '/doclegal/user/acceptances'
            }
        },
    }, events: {
        url: 'https://back-baguu.algorithmdata.ai',
        tag: '/tags',
    },
    urlMaps: 'https://www.google.com/maps/search/?api=1&query={lat}%2C{lng}&query_place_id={placeid}',
    baguuBusines: '1',
    makePayment: true,
    GOOGLE_MAPS_KEY: 'AIzaSyAv5-i1-gZNYTsK6FW2s0vUWWvuRRizxKs',

};

/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
import 'zone.js/plugins/zone-error';   // Included with Angular CLI.
